import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AccordionItem } from "./AccordionItem";
import { AccordionWrapper } from "./Accordion.styles";
export var Accordion = function(param) {
    var content = param.content;
    return /*#__PURE__*/ _jsx(AccordionWrapper, {
        children: content.map(function(item, index) {
            return /*#__PURE__*/ _jsx(AccordionItem, {
                item: item,
                index: index
            }, item.prompt);
        })
    });
};
